<template>
  <form-panel
    :title="currentOpportunity.title"
    width="large"
    @closePanel="onCloseModal">
    <div class="main">
      <el-row
        :gutter="10"
        style="margin-top: 15px;">
        <el-col :span="4">
          <b>Fecha</b>
          <p>{{ currentOpportunity.createdAt | date('DD/MM/YYYY') }}</p>
        </el-col>
        <el-col :span="4">
          <b>Hora</b>
          <p>{{ currentOpportunity.createdAt | date('HH:MM') }}</p>
        </el-col>
        <el-col :span="4">
          <b>Tipo</b>
          <p>{{ getType(currentOpportunity.type) }}</p>
        </el-col>
        <el-col :span="4">
          <b>Equipo</b>
          <p>{{ currentOpportunity.machineryType }}</p>
        </el-col>
        <el-col :span="4">
          <b>Modelo</b>
          <p>{{ currentOpportunity.model }}</p>
        </el-col>
        <el-col :span="4">
          <b>Cantidad</b>
          <p>{{ currentOpportunity.quantity }}</p>
        </el-col>
      </el-row>
      <el-row style="margin-top: 15px;">
        <el-col :span="12">
          <b>Descripción</b>
          <p>{{ currentOpportunity.description }}</p>
        </el-col>
        <el-col :span="12">
          <b>Estatus: </b>
          <div
            :class="{ 'success': currentOpportunity.status === 'Aceptada', 'danger': currentOpportunity.status === 'Rechazada', 'info': currentOpportunity.status === 'En Proceso' }"
            class="tag">
            {{ currentOpportunity.status }}
          </div>
        </el-col>
      </el-row>
      <div class="tabs">
        <form-tabs
          :tabs-label-header="headerTabs"
          :active-filter="false"
          @onClickTab="onChangeTab"/>
        <trackings-detail-item
          v-if="trackings.length > 0"
          :opportunity="currentOpportunity"
          :trackings="trackings"
          @newTracing="createNewTracing"/>
        <template v-else>
          <not-found
            v-if="profile.role === 'gerente_dealer'"
            :visible="visible"/>
          <not-found
            v-else
            @addElement="createNewTracing"/>
        </template>
      </div>
    </div>
    <create-tracking
      v-if="showTrackingPanel"
      :opportunity="currentOpportunity"
      :update="updateTracking"
      :is-final="final"/>
  </form-panel>
</template>

<script>
import FormPanel from '@/components/_shared/form-panel'
import FormTabs from '@/components/_shared/form-tabs'
import trackingsDetailItem from '@/modules/trackings/trackings-detail-item'
import CreateTracking from '@/views/app/tracings/tracings-create-view'
import NotFound from '@/components/_shared/not-found'

export default {
  name: 'ClientsOpportunityDetail',
  components: {
    FormTabs,
    trackingsDetailItem,
    FormPanel,
    CreateTracking,
    NotFound
  },
  props: {
    currentOpportunity: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      activeComponent: 'trackings-detail-item',
      notItems: false,
      headerTabs: [
        {
          name: 'Seguimientos',
          active: 'one',
          view: 'trackings-detail-item'
        }
      ],
      refreshComponent: 0,
      updateTracking: false,
      final: false,
      visible: false
    }
  },
  computed: {
    showTrackingPanel () {
      return this.$store.getters['app/showTrackingPanel']
    },
    profile () {
      return this.$store.getters['profile/me']
    },
    trackings () {
      return this.$store.getters['trackings/items']
    }
  },
  mounted () {
    this.$store.dispatch('trackings/query', {
      'filters[where][opportunityId][eq]': this.currentOpportunity.id,
      sort: 'dueDate asc',
      limit: 1000
    })
      .then(({data}) => {
        if (data.items.length === 0) {
          this.notItems = true
        }
      })
  },
  methods: {
    onChangeTab (val) {
      for (let name in this.headerTabs) {
        if (val.label === this.headerTabs[name].name) {
          this.activeComponent = this.headerTabs[name].view
        }
      }
    },
    createNewTracing (update, final) {
      if (update) {
        this.updateTracking = true
        this.final = final
      } else {
        this.updateTracking = false
      }
      this.$store.dispatch('app/toggleTrackingPanel')
    },
    onCloseModal () {
      this.$store.dispatch('app/toggleOpportunityDetailPanel')
    },
    getType (type) {
      return type === 'SALE' ? 'Venta' : 'Post-Venta'
    }
  }
}
</script>

<style scoped lang="scss">
  .main{
    padding: 25px 30px 0;
    .name {
      color: #B5AFAF;
      font-family: Lato;
      font-size: 14px;
      font-weight: 400;
      margin: 0 0 30px;
    }
    b {
      color: #3E3E3E;
      font-family: Lato;
      font-size: 12px;
      font-weight: 700;
      margin: 0 0 12px;
      display: block;
    }
    p {
      margin: 0;
      @include font-primary(13px, regular);
      color: #707070;
    }
    .tabs{
      margin: 0 -30px;
      height: calc(100% - 230px);
      overflow: auto;
    }
    .tag {
      display: inline-block;
      @include font-primary(11px, regular);
      padding: 5px 12px;
      border-radius: 2px;
      color: #ffffff;
      &.danger{
        background-color: $--color-danger;
      }
      &.warning{
        background-color: $--color-warning;
      }
      &.success{
        background-color: $--color-success;
      }
      &.info{
        background-color: #409eff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/customers/customers-opportunity-detail.vue